export default "__VITE_ASSET__BKwkn_We__"